module.exports = __webpack_public_path__ + "img/sucess04.d960c4bf.png";